/* H7 native-page kit behaviour.
   One file for every paid landing page: the comparison scrollers and the
   reading progress bar. Everything is opt-in by data attribute, so a page that
   carries none of these components pays nothing for including it. */

(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- comparison scrollers ---------- */

  const setUpCompare = (root) => {
    const scroller = root.querySelector('[data-h7-compare-scroller]');
    const thumb = root.querySelector('[data-h7-compare-thumb]');
    if (!scroller) return;

    const paint = () => {
      const span = scroller.scrollWidth - scroller.clientWidth;
      if (span <= 0) return;
      const pct = scroller.scrollLeft / span;
      if (scroller.scrollLeft > 8) root.dataset.scrolled = 'true';
      if (!thumb) return;
      const track = thumb.parentElement.clientWidth;
      const width = thumb.offsetWidth;
      thumb.style.transform = `translateX(${pct * (track - width)}px)`;
    };

    const sizeThumb = () => {
      if (!thumb) return;
      const ratio = scroller.clientWidth / scroller.scrollWidth;
      thumb.style.width = `${Math.min(100, Math.max(18, ratio * 100))}%`;
    };

    const refresh = () => {
      // Under about a column of overflow there is nothing worth advertising,
      // and a thumb that fills its track reads as a bug.
      const span = scroller.scrollWidth - scroller.clientWidth;
      root.dataset.scrollable = span > 24 ? 'true' : 'false';
      sizeThumb();
      paint();
    };

    refresh();
    scroller.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', refresh, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(refresh).observe(scroller);

    // Any real interaction retires the hint, nudge or no nudge.
    ['pointerdown', 'wheel', 'touchstart'].forEach((evt) =>
      scroller.addEventListener(evt, () => { root.dataset.scrolled = 'true'; }, { passive: true, once: true })
    );

    // A table that only hints at a fourth column with a thin bar gets ignored.
    // One short nudge the first time it comes into view teaches the gesture.
    if (reduced || !('IntersectionObserver' in window)) return;
    let nudged = false;
    const watcher = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || nudged) return;
        if (root.dataset.scrollable !== 'true') return;
        nudged = true;
        watcher.disconnect();
        scroller.scrollTo({ left: 56, behavior: 'smooth' });
        window.setTimeout(() => scroller.scrollTo({ left: 0, behavior: 'smooth' }), 620);
      });
    }, { threshold: 0.4 });
    watcher.observe(root);
  };

  document.querySelectorAll('[data-h7-compare]').forEach(setUpCompare);

  /* ---------- reading progress ---------- */

  const bar = document.querySelector('[data-h7-native-progress]');
  const scope = document.querySelector('[data-h7-native-scope]');
  if (bar && scope) {
    const paint = () => {
      const span = scope.offsetHeight - window.innerHeight;
      if (span <= 0) {
        bar.style.width = '0%';
        return;
      }
      const pct = Math.min(1, Math.max(0, (window.scrollY - scope.offsetTop) / span));
      bar.style.width = `${pct * 100}%`;
    };
    paint();
    window.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint, { passive: true });
  }
})();
